export default __webpack_public_path__ + "static/media/transfer_posting.41ae2f84.webp";